var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.8 3.1a1 1 0 00-.8-1.6H2.981a1 1 0 00-.8 1.6l7.808 10.491V23.5a1 1 0 001.6.8l2-1.5a1 1 0 00.4-.8v-8.41L21.8 3.1z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjEuOCAzLjFDMjIuMDI3MiAyLjc5Njk4IDIyLjA2MzggMi4zOTE1NyAyMS44OTQ0IDIuMDUyNzlDMjEuNzI1IDEuNzE0IDIxLjM3ODcgMS41IDIxIDEuNUgyLjk4MDk2QzIuNjAyMTkgMS41IDIuMjU1OTMgMS43MTQgMi4wODY1NCAyLjA1Mjc5QzEuOTE3MTQgMi4zOTE1NyAxLjk1MzcgMi43OTY5OCAyLjE4MDk2IDMuMUw5Ljk4ODk3IDEzLjU5MVYyMy41QzkuOTg4OTcgMjMuODc4OCAxMC4yMDMgMjQuMjI1IDEwLjU0MTggMjQuMzk0NEMxMC44ODA1IDI0LjU2MzggMTEuMjg1OSAyNC41MjczIDExLjU4OSAyNC4zTDEzLjU4OSAyMi44QzEzLjg0MDggMjIuNjExMSAxMy45ODkgMjIuMzE0OCAxMy45ODkgMjJWMTMuNTlMMjEuOCAzLjFaIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgFilter as ReactComponent };